import React from "react";
import { BiPhone } from "react-icons/bi";
import { AiOutlineMail } from "react-icons/ai";
import { FaRegHandPointRight } from "react-icons/fa";
import { FaPrayingHands } from "react-icons/fa";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <div className="container-fluid p-0">
      <div className="row m-0 bg-light-gray">
        <div className="col-md-10">
          <ul
            className="d-flex flex-column-reverse flex-md-row m-0 p-0 justify-content-between text-center text-white px-md-5"
            type="none"
          >
            <li className="quick-call">
              <BiPhone className="text-warning" />{" "}
              <Link
                to={{
                  pathname: "tel:8960945036896094493689609448368960944736",
                }}
                className="text-white text-decoration-none font-sm"
              >
                Support - +919451871624,+917236978721
              </Link>
            </li>{" "}
            <span className="d-md-block d-none">|</span>
            <li className="quick-email">
              <AiOutlineMail className="text-warning" />{" "}
              <Link
                to={{ pathname: "mailto:yadavrajesh20130@gmail.com" }}
                className="text-white ml-1 text-decoration-none font-sm"
              >
                anamika387@gmail.com
              </Link>
            </li>{" "}
            <span className="d-md-block d-none">|</span>
            <li className="notice">
              <FaRegHandPointRight className="text-warning" />{" "}
              <Link to="/" className="text-white text-decoration-none font-sm">
                स्थापना वर्ष : 18-07-2009
              </Link>
            </li>
            <span className="d-md-block d-none">|</span>
            <li className="align-items-center">
              <FaPrayingHands className="text-warning" />
              &nbsp;
              <span className="text-white text-decoration-none font-sm">
                Welcome to our College Website.
              </span>
            </li>
          </ul>
        </div>
      </div>
      <header>
        <Container className="px-md-2 p-0 py-2 text-md-start text-center ">
          <h3 className="text-light-gray" style={{ marginBottom: "3px" }}>
            Gayatri Inter College Daulatpur - Nauwa Kuan
          </h3>

          <span className="text-secondary">
            Vill - Daulatpur, Post - Dabhasemar , Block - Masaudha, Tesil-Sadar,
            Ayodhya , Uttar Pradesh – 224133
          </span>
        </Container>
      </header>
      <div id="bottom-head">
        <Navbar
          expand="lg"
          variant="dark"
          style={{ backgroundColor: "#49688e" }}
        >
          <Container className="p-0">
            <Navbar.Toggle
              label="Menu"
              className="mx-auto"
              aria-controls="basic-navbar-nav"
            />

            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto text-center text-md-start">
                <Link to="/" className="nav-link">
                  Home
                </Link>
                <Link to="/about" className="nav-link">
                  About Us
                </Link>
                <NavDropdown title="School" id="basic-nav-dropdown">
                  <Link to="/missionandvision" className="dropdown-item">
                    Mission & vision
                  </Link>
                  <Link to="/infrastructure" className="dropdown-item">
                    Infrastructure
                  </Link>
                  <Link to="/curriculam" className="dropdown-item">
                    Curriculam
                  </Link>
                </NavDropdown>
                <NavDropdown title="Management" id="basic-nav-dropdown">
                  <Link to="/" className="dropdown-item">
                    Society
                  </Link>
                  <Link to="/" className="dropdown-item">
                    School Managing Committee
                  </Link>
                </NavDropdown>
                <NavDropdown title="Admission" id="basic-nav-dropdown">
                  <Link to="/" className="dropdown-item">
                    Apply Online
                  </Link>
                  <Link to="/" className="dropdown-item">
                    Admission Procedure
                  </Link>

                  <Link to="/" className="dropdown-item">
                    Fee Structure
                  </Link>
                </NavDropdown>
                <NavDropdown title="Our Staff" id="basic-nav-dropdown">
                  <Link to="/teacher" className="dropdown-item">
                    Teaching
                  </Link>
                </NavDropdown>
                <NavDropdown title="Facilities" id="basic-nav-dropdown">
                  <Link to="/" className="dropdown-item">
                    Library
                  </Link>
                  <Link to="/" className="dropdown-item">
                    Other
                  </Link>
                </NavDropdown>
                <Link to="/gallery" className="nav-link">
                  Gallery
                </Link>
                <Link to="/contact" className="nav-link">
                  Contact Us
                </Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </div>
  );
};

export default Header;
